// components/SessionManager.jsx
import { useEffect } from 'react';

const SessionManager = () => {
    useEffect(() => {
        const checkSession = () => {
            const expiry = localStorage.getItem('expiry');
            if (expiry && Date.now() > Number(expiry)) {
                console.log('Session expired. Logging out...');
                localStorage.clear();
                window.location.href = '/signin';
            }
        };

        checkSession(); // ✅ Run immediately on component mount (page load)
        const interval = setInterval(checkSession, 60000); // 🔁 Then check every 60 seconds

        return () => clearInterval(interval); // 🧹 Cleanup on unmount
    }, []);

    return null;
};

export default SessionManager;
